export default (fee, sendAmount) => {
  let feeValue = 0;
  if (sendAmount === '' || isNaN(parseFloat(sendAmount))) {
    feeValue = 0;
  } else if (fee.calculationType === 'PERCENTAGE') {
    feeValue = (parseFloat(sendAmount) / 100) * fee.amount;
  }
  return feeValue;
};
